import { useMemo } from "react";
import { PlatformNext, DefaultStreamerOptions } from "@pureweb/platform-sdk";
import { LaunchRequestOptions } from "@pureweb/platform-sdk-react";
import * as qs from "query-string";
import { parseQueryParameters, initializeAudio } from "../utils";
import { DEFAULT_AUDIO_VOLUME } from "../constants";
import { ClientJson } from "../types";
import clientConfig from "../client.json";

const client: ClientJson = clientConfig as ClientJson;

export const usePlatform = () => {
  const {
    platform,
    clientOptions,
    audio,
    streamerOptions,
    launchRequestOptions,
  } = useMemo(() => {
    // Parse query parameters
    const clientOptions = parseQueryParameters(client);

    // Initialize audio
    const audio = initializeAudio(DEFAULT_AUDIO_VOLUME);

    // Initialize platform reference
    const platform = new PlatformNext();
    platform.initialize({
      endpoint: clientOptions.Endpoint || "https://api.pureweb.io",
    });

    // Setup streamer options
    const streamerOptions = { ...DefaultStreamerOptions };

    // Setup launch request options
    const launchRequestOptions: LaunchRequestOptions = {
      regionOverride: qs.parse(window.location.search)[
        "regionOverride"
      ] as string,
    };

    return {
      platform,
      clientOptions,
      audio,
      streamerOptions,
      launchRequestOptions,
    };
  }, []);

  return {
    platform,
    clientOptions,
    audio,
    streamerOptions,
    launchRequestOptions,
    client,
  };
};
